import React, { useContext, useEffect, useMemo, useState } from "react";

import { Grid } from "@material-ui/core";

import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import { AppContext } from "../../App";

import { InputDropDowList2 as InputDropDowList, InputSelector, InputText } from "../../components";
import ApiVariables from "../../api/system/variables/ApiVariables";

export default function Variables({ menu, onLoadVariables, currentValues }) {
    const { setLoading, showMessageError, showMessageInfo } = useContext(AppContext);

    const [open, setOpen] = useState(false);
    const [modeAdd, setModeAdd] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [variableId, setVariableId] = useState(0);
    const [name, setName] = useState("");
    const [overrideVariable, setOverrideVariable] = useState(false);

    const onLoadDataSource = async (menuLoad) => {
        setLoading(true);

        try {
            const result = await ApiVariables().menu(menuLoad);

            if (result.status) {
                setDataSource(result.data);
                setVariableId(result.data[0].id);
            } else {
                setDataSource([]);
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError({ active: true, message: e.message });
        } finally {
            setLoading(false);
        }
    };

    const onSave = async (values, name, variableId) => {
        setLoading(true);

        // Mode Add and New Value
        if (name && dataSource?.length) {
            const dataFind = dataSource.find((rec) => String(rec.name).toUpperCase() === String(name).toUpperCase());

            if (dataFind) {
                showMessageInfo(`Já existe variável com este nome (${dataFind.id})`);
                return false;
            }
        }

        try {
            let result = null;

            if (name) {
                result = await ApiVariables().apiDefault.creates({
                    name,
                    menu,
                    values: JSON.stringify(values),
                });
            } else {
                result = await ApiVariables().apiDefault.update(variableId, {
                    values: JSON.stringify(values),
                });
            }

            if (!result.status) {
                showMessageError(result.message);
                return;
            } else {
                const dataSourceCustom = [...dataSource];

                if (name) {
                    dataSourceCustom.unshift(result.data.data[0]);
                } else {
                    const dataFindIndex = dataSourceCustom.findIndex((rec) => rec.id === variableId);

                    if (dataFindIndex > -1) {
                        dataSourceCustom[dataFindIndex] = result.data.data[0];
                    }
                }

                setDataSource(dataSourceCustom);
            }

            showMessageInfo("Variável salva com sucesso!");
        } catch (e) {
            showMessageError({ active: true, message: e.message });
        } finally {
            setLoading(false);
        }

        return true;
    };

    const dataSourceView = useMemo(() => {
        return dataSource.map((rec) => {
            return {
                text: rec.name,
                value: rec.id,
            };
        });
    }, [dataSource]);

    useEffect(() => {
        onLoadDataSource(menu);
    }, [menu]);

    useEffect(() => {
        setName("");
    }, [open]);

    return (
        <>
            <Button
                style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                size="small"
                variant="contained"
                color="secondary"
                onClick={() => {
                    setOpen(true);
                    setModeAdd(false);
                    setOverrideVariable(true);
                }}
                disabled={!dataSource?.length}
            >
                Carregar Variável
            </Button>
            <Button
                style={{ float: "left", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                size="small"
                variant="contained"
                color="primary"
                onClick={() => {
                    setOpen(true);
                    setModeAdd(true);
                    setOverrideVariable(false);
                }}
            >
                Gravar Variável
            </Button>
            <Dialog
                fullWidth
                maxWidth={"sm"}
                open={open}
                onClose={(e, reason) => {
                    if (!["backdropClick", "escapeKeyDown"].includes(reason)) {
                        setOpen(false);
                    }
                }}
            >
                <DialogTitle>Manutenção de Variáveis</DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        {dataSource?.length > 0 && modeAdd && (
                            <Grid item xs={12} sm={12}>
                                <InputSelector
                                    label={"Sobrescrever Variável"}
                                    value={overrideVariable || false}
                                    onChangeValue={(e) => setOverrideVariable(e.target.checked)}
                                />
                            </Grid>
                        )}
                        {modeAdd && !overrideVariable && (
                            <Grid item xs={12} sm={12}>
                                <InputText label="Nome Variável" value={name} onChangeValue={(e) => setName(e.target.value)} />
                            </Grid>
                        )}
                        {dataSource?.length > 0 && overrideVariable && (
                            <Grid item xs={12} sm={12}>
                                <InputDropDowList
                                    label="Selecione Variável"
                                    value={variableId}
                                    onChangeValue={(e) => setVariableId(Number(e.target?.value) || 0)}
                                    defaultValue={1}
                                    data={dataSourceView}
                                />
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <Button
                                style={{ float: "right", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                style={{ float: "right", marginTop: "5px", marginBottom: "5px", marginRight: "5px" }}
                                size="small"
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    if (modeAdd) {
                                        if (!name && !dataSource.length) {
                                            showMessageInfo("Informe um nome para variável.");
                                        } else {
                                            onSave(currentValues, name, variableId).then((res) => {
                                                if (res) {
                                                    setOpen(false);
                                                }
                                            });
                                        }
                                    } else {
                                        setOpen(false);

                                        const dataFind = dataSource.find((rec) => rec.id === variableId);
                                        onLoadVariables(menu, dataFind.values);
                                    }
                                }}
                            >
                                {modeAdd ? "Gravar" : "Carregar"}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
}
